/**
 * Whether there is anybody to write to, in one place.
 *
 * Three pages depend on this and they must not disagree. The contact page says
 * how to report somebody; the safety and guidelines pages send people there.
 * When the address was only on the contact page, emptying it left the other two
 * still promising a channel — a dead end on exactly the pages where being
 * wrong costs the most.
 *
 * Empty is a legitimate state and every consumer has to handle it: printing an
 * address nobody reads is worse than saying there is not one, because somebody
 * writes into a void and concludes they were ignored.
 */
/**
 * Annotated `string` rather than left to infer. Without it TypeScript narrows
 * this to its own literal, and `canReport` becomes a comparison the compiler
 * rejects as impossible — which would be true of today's value and is exactly
 * the flexibility this constant exists to have.
 */
export const CONTACT_EMAIL: string = 'contact@openroad.nz';

export const canReport = CONTACT_EMAIL !== '';
